export const formConfig = {
  basicInformation: {
    title: "Basic Information",
    fields: [
      {
        name: "productName",
        label: "Product Name",
        type: "text",
        placeholder: "Enter product name",
        required: true
      },
      {
        name: "productCode",
        label: "Product Code",
        type: "select",
        required: true,
        options: [],
        placeholder: "Select product code"
      },
      
      {
        name: "productOwner",
        label: "Product Owner",
        type: "text",
        placeholder: "Enter product owner name",
        required: true
      },
      {
        name: "dataLayer",
        label: "Product Data Layer",
        type: "select",
        required: true,
        options: [
          { value: "ingestion", label: "Ingestion" },
          { value: "bronze", label: "Bronze" },
          { value: "silver", label: "Silver" },
          { value: "gold", label: "Gold" },
          { value: "analyticalProduct", label: "Analytical Product" }

        ],
        placeholder: "Select data layer"
      },
      {
        name: "domain",
        label: "Parent Domain",
        type: "select",
        required: true,
        options: [],
        placeholder: "Select domain",
        apiField: "parent_domains",
        valueField: "parent_domain_name",
        labelField: "parent_domain",
        idField: "parent_domain_id"
      },
      {
        name: "subDomain",
        label: "Domain",
        type: "select",
        required: true,
        options: [],
        placeholder: "Select sub domain",
        dependsOn: "domain",
        apiField: "domains",
        valueField: "domain",
        labelField: "domain",
        idField: "domain_id"
      },
      {
        name: "subSubDomain",
        label: "Sub Domain",
        type: "select",
        required: true,
        options: [],
        placeholder: "Select sub sub domain",
        dependsOn: "subDomain",
        apiField: "sub_domains",
        valueField: "sub_domain",
        labelField: "sub_domain",
        idField: "sub_domain_id"
      },
      {
        name: "description",
        label: "Product Description",
        type: "textarea",
        placeholder: "Describe your data product",
        required: true
      },
      {
        name: "productTag",
        label: "Product Tags",
        type: "tagInput",
        required: false,
        suggestions: ["Sales", "Marketing", "Finance", "HR", "Operations", "Analytics", "Reporting", "Forecasting", "Planning", "Logistics"]
      },
    ]
  },
  marketInformation: {
    title: "Market Information",
    fields: [
      {
        name: "marketRegion",
        label: "Market Region",
        type: "select",
        required: true,
        options: [],
        placeholder: "Select region"
      },
      {
        name: "marketCountry",
        label: "Country",
        type: "select",
        required: true,
        options: [],
        placeholder: "Select country"
      },
      {
        name: "lineOfBusiness",
        label: "Line of Business",
        type: "select",
        required: true,
        options: [
          { value: "", label: "Select line of business" },
          { value: "mw", label: "MW" },
          { value: "health", label: "Health and Wellness" },
          { value: "immersive", label: "Immersive Experience" }
        ],
        placeholder: "Select line of business"
      }
    ]
  },
  hierarchyInformation: {
    title: "Hierarchy Information",
    fields: [
      {
        name: "hierarchy_1",
        label: "Hierarchy 1",
        type: "text",
        required: false,
        placeholder: "Enter Heirarchy 1"
      },
      {
        name: "hierarchy_2",
        label: "Hierarchy 2",
        type: "text",
        required: false,
        placeholder: "Enter Heirarchy 2"
      },
      {
        name: "hierarchy_3",
        label: "Hierarchy 3",
        type: "text",
        required: false,
        placeholder: "Enter Heirarchy 3"
      },
      {
        name: "hierarchy_4",
        label: "Hierarchy 4",
        type: "text",
        required: false,
        placeholder: "Enter Heirarchy 4"
      },
      {
        name: "hierarchy_5",
        label: "Hierarchy 5",
        type: "text",
        required: false,
        placeholder: "Enter Heirarchy 5"
      },
    ]
  },
  costInformation: {
    title: "Cost Information",
    costTypes: [
      {
        name: "developmentCosts",
        label: "Total Development Cost",
        type: "costWithDates",
        required: true,
        showDatesOnValue: true
      },
      {
        name: "supportCosts",
        label: "Total Support Cost",
        type: "costWithDates",
        required: true,
        showDatesOnValue: true
      },
      {
        name: "operationCosts",
        label: "Total Operation Cost",
        type: "costWithDates",
        required: true,
        showDatesOnValue: true
      }
    ],
    thresholds: [
      {
        name: "costThreshold",
        label: "Cost Threshold for Data Processing",
        type: "number",
        required: true,
        placeholder: "Enter cost threshold in $"
      },
      {
        name: "sizeThreshold",
        label: "Size Threshold for Data",
        type: "numberWithUnit",
        required: true,
        unitOptions: [
          { value: "MB", label: "MB" },
          { value: "GB", label: "GB" },
          { value: "TB", label: "TB" }
        ]
      }
    ]
  },
  serviceLevelAgreement: {
    title: "Service Level Agreement",
    fields: [
      {
        name: "slaResponseTime",
        label: "SLA - Response Time",
        type: "slaResponseTime",
        required: true,
        placeholder: "Enter response time"
      },
      {
        name: "slaUptime",
        label: "SLA - Uptime",
        type: "number",
        required: true,
        placeholder: "Enter uptime percentage (%)"
      }
    ]
  },
  additionalInformation: {
    title: "Additional Information",
    fields: [
      {
        name: "minExpectedUsers",
        label: "Minimum Expected Users",
        type: "number",
        required: true,
        placeholder: "Enter minimum number of users"
      },
      {
        name: "maxExpectedUsers",
        label: "Maximum Expected Users",
        type: "number",
        required: true,
        placeholder: "Enter maximum number of users"
      },
      {
        name: "valueMapping",
        label: "Value Mapping",
        type: "text",
        required: true,
        placeholder: "Enter value mapping"
      },
      {
        name: "productDocumentationUrl",
        label: "URL Field for Product Documentation",
        type: "url",
        required: false,
        placeholder: "Enter URL for product documentation"
      },
      {
        name: "assetSource",
        label: "Select Asset Source",
        type: "multiselect",
        required: true,
        options: [
          { value: "uc", label: "UC" },
          { value: "adls", label: "ADLS" },
          { value: "manual", label: "Manual" }
        ],
        placeholder: "Select asset source"
      }
    ]
  }
};